<template>
  <HomeType3Content
    ref="contentRef"
    :homeInfo="homeInfo"
    :expertConfig="expertConfig"
  />
</template>

<script>
import HomeType3Content from './home-type3-content.vue'

export default {
  name: 'HomeType3Index',

  components: {
    HomeType3Content
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({})
    },

    expertConfig: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style>
/* 落地页静态样式：来自保存的 Shopify 资源 */
/* 主题 :root 变量兜底，需在 base 之前，避免 var(--font-h3--family) 等未定义 */
@import './assets/vars.css';
@import './assets/base.css';
@import './assets/styles.css';

/*
 * Recent pickups（.hs-item）：base.css 全局 img 规则易与横向 flex 条冲突，需在主题之后强制还原布局。
 */
.home-type3-root .hs-list {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: stretch;
}

.home-type3-root a.hs-item {
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  min-width: 260px;
  padding: 12px;
  border: 0;
  background: transparent;
  text-decoration: none !important;
  color: inherit;
  box-sizing: border-box;
}

.home-type3-root .hs-thumb {
  flex: 0 0 80px !important;
  flex-shrink: 0 !important;
  width: 80px !important;
  height: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  overflow: hidden;
  border-radius: 12px;
  background: #f2f2f2;
  pointer-events: none;
}

.home-type3-root img.hs-thumb-img {
  width: 100% !important;
  height: 100% !important;
  max-width: none !important;
  object-fit: cover !important;
  display: block !important;
}

.home-type3-root .hs-meta {
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
}

.home-type3-root .hs-chev {
  flex-shrink: 0;
  margin-left: auto;
  font-size: 22px;
  opacity: 0.3;
}

@media (max-width: 768px) {
  .home-type3-root a.hs-item {
    min-width: 82%;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  }

  .home-type3-root .hs-thumb {
    flex-basis: 72px !important;
    width: 72px !important;
    height: 72px !important;
    min-width: 72px !important;
    max-width: 72px !important;
  }

  .home-type3-root .hs-price {
    font-size: 18px;
  }
}
</style>
